import React from 'react';
import { motion } from 'framer-motion';
export function FloatingParticles() {
  // Generate random particles
  const particles = Array.from({
    length: 20
  }).map((_, i) => ({
    id: i,
    size: Math.random() * 60 + 20,
    x: Math.random() * 100,
    y: Math.random() * 100,
    duration: Math.random() * 20 + 20,
    delay: Math.random() * 10,
    opacity: Math.random() * 0.15 + 0.05,
    shape: Math.random() > 0.6 ? 'circle' : Math.random() > 0.3 ? 'square' : 'diamond',
    color: Math.random() > 0.5 ? '#C9A962' : '#F5E6C8' // Gold or Light Gold
  }));
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-0" data-id="element-156">
      {particles.map(particle => <motion.div key={particle.id} className="absolute" style={{
      left: `${particle.x}%`,
      top: `${particle.y}%`,
      width: particle.size,
      height: particle.size,
      borderRadius: particle.shape === 'circle' ? '50%' : particle.shape === 'square' ? '12px' : '0px',
      transform: particle.shape === 'diamond' ? 'rotate(45deg)' : 'none',
      backgroundColor: particle.color,
      opacity: particle.opacity,
      filter: 'blur(8px)'
    }} animate={{
      y: [0, -100, 0],
      x: [0, 50, 0],
      rotate: [0, 180, 360]
    }} transition={{
      duration: particle.duration,
      repeat: Infinity,
      ease: 'linear',
      delay: particle.delay
    }} data-id="element-157" />)}

      {/* Ambient Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#FDF8F3]/80 via-transparent to-[#FAE5D3]/50 mix-blend-overlay" data-id="element-158" />
    </div>;
}